/** Türkçe sözlük · yedek. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const yedek = {
  hedefAdi: {
    yerelKlasor: "Eşitlenen klasör",
    parafonSunucu: "Parafon sunucusu",
  },

  /** Sağlayıcı listesindeki notlar ve kapalılık sebepleri (`yedek/hedefler`). */
  hedef: {
    yapilandirilmamis: "Bu sunucuda yapılandırılmamış (uygulama kaydı yok — deploy/OKUBENI.md).",
    adYapilandirilmamis: (ad: string, sebep: string) => `${ad} ${sebep}`,
    merkezYok: "Bu oturumda Parafon sunucusuna bağlantı kapalı.",
    sunucuNot: (enAz: number, ay: number) =>
      `Hesap gerekmez: kasa koduyla, şifreli. Kasa parolası en az ${enAz} karakter olmalı. Hiçbir cihazdan ${ay} ay açılmayan klasör silinir.`,
    dropboxNot: "Uygulama klasörüne yazar. Bir kez bağlanınca kendiliğinden sürer.",
    googleNot:
      "Gizli uygulama klasörüne yazar. Google tarayıcı uygulamalarına uzun süreli izin vermiyor: saatte bir, bekleyen yedek varsa tek tık ister.",
    onedriveNot:
      "Uygulama klasörüne yazar. Microsoft tarayıcı uygulamalarının iznini 24 saatle sınırlıyor: günde bir, tek tık ister.",
    klasorNot:
      "Bilgisayardaki Google Drive / Dropbox / iCloud / OneDrive klasörünü seçin; buluta masaüstü istemcisi taşır. Tarayıcı yeniden açılınca bir kez izin sorabilir.",
    sunucuSecin: "Yeni kasa kodu mu, var olan kod mu — seçin.",
    icloudNotu:
      "iPhone'da tarayıcıdan iCloud'a doğrudan yazılamıyor (Apple'ın ücretli geliştirici üyeliği gerekiyor). Bilgisayarda (Mac ya da Windows, Chrome veya Edge) iCloud Drive klasörünü seçin; iCloud onu kendisi eşitler.",

    // Eşitlenen klasör
    klasorBrave:
      "Brave'de bu özellik kapalı: adres çubuğuna brave://flags/#file-system-access-api yazın → Enabled → tarayıcıyı yeniden başlatın.",
    klasorMobil: "Mobil tarayıcılarda yok (masaüstü Chrome ya da Edge gerekir).",
    klasorFirefox: "Firefox bu özelliği desteklemiyor (masaüstü Chrome ya da Edge gerekir).",
    klasorSafari: "Safari bu özelliği desteklemiyor (masaüstü Chrome ya da Edge gerekir).",
    klasorYok: "Bu tarayıcıda yok (masaüstü Chrome ya da Edge gerekir).",
    klasorSecilemiyor: "Bu tarayıcı klasör seçmeyi desteklemiyor (masaüstü Chrome ya da Edge gerekir).",
    klasorIzinYok: "Klasöre yazma izni verilmedi.",
    klasorIzinGeriAlindi: "Klasör izni geri alınmış — yeniden bağlanın.",
    klasorKayboldu: "Seçilen klasör artık yok (taşınmış ya da silinmiş olabilir). Yeni bir klasör seçin.",
    klasorKonum: (ad: string) => `Klasör: ${ad}`,

    // Google Drive
    googleAnahtarYok: "Google erişim anahtarı dönmedi.",
    googleIzinYok: "Google, uygulama klasörüne erişim iznini vermedi.",
    googleSureDoldu: "Google erişim süresi doldu — yeniden bağlanın.",
    googleReddetti: "Google erişimi reddetti — yeniden bağlanın.",
    googleKonum: "Google Drive › uygulama verisi (gizli klasör)",
    googleDosyaYok: (ad: string) => `Google Drive'da ${ad} bulunamadı.`,

    // Dropbox
    dropboxKodYok: "Dropbox yetki kodu dönmedi.",
    dropboxYenilemeYok: "Dropbox yenileme anahtarı vermedi (uygulama kaydında 'offline' erişim açık mı?).",
    dropboxGeriAlindi: "Dropbox bağlantısı geri alınmış — yeniden bağlanın.",
    dropboxReddetti: "Dropbox erişimi reddetti — yeniden bağlanın.",
    dropboxKonum: "Dropbox › Uygulamalar › (uygulama kaydının adı)",

    // OneDrive
    onedriveKodYok: "OneDrive yetki kodu dönmedi.",
    onedriveAnahtarYok: "OneDrive erişim anahtarı vermedi.",
    onedriveGunlukDoldu: "OneDrive oturumunun günlük süresi doldu — yeniden bağlanın.",
    onedriveDustu: "OneDrive bağlantısı düştü — yeniden bağlanın.",
    onedriveReddetti: "OneDrive erişimi reddetti — yeniden bağlanın.",
    onedriveKonum: "OneDrive › Uygulamalar › (uygulama kaydının adı)",
    onedriveIndirmeAdresiYok: (ad: string) => `OneDrive ${ad} için indirme adresi vermedi.`,
    onedriveIndirme: (durum: number) => `OneDrive indirme ${durum}`,

    // Parafon sunucusu
    kodTaninmadi:
      "Kasa kodu sunucuda bulunamadı: başka bir cihazda yenilenmiş ya da 7 ay hiçbir cihazdan açılmadığı için silinmiş olabilir. Yeni kodu girin.",
    sunucuCokIstek: "Sunucu bu bağlantıdan kısa sürede çok istek aldı; biraz sonra yeniden deneyin.",
    sunucuDolu: "Parafon sunucusunun yedek alanı şu an dolu; yeni kasa kodu açılamıyor. Başka bir hedef seçin.",
    klasorSinir: "Bu kasa kodunun klasörü sınırına ulaştı (dosya sayısı ya da toplam boyut).",
    dosyaBuyuk: "Yedek dosyası sunucunun tek dosya sınırını aşıyor.",
    govdeBuyuk: "Yedek dosyası sunucunun kabul ettiği boyutu aşıyor; sunucu yapılandırması güncellenmeli.",
    kodBicimi: (n: number) => `Kasa kodu ${n} harf ve rakamdan oluşur; yazdığınız kod eksik ya da hatalı.`,
    kodYok: "Bu kasa kodu sunucuda yok. Kodu, kasayı kullanan öbür cihazdaki Ayarlar'dan kontrol edin.",
    kodAcilamadi: "Yeni kasa kodu açılamadı.",
    sunucuKonum: (ay: number) =>
      `Parafon sunucusu › kasa kodunuzun klasörü (hiçbir cihazdan ${ay} ay açılmazsa silinir)`,
    sunucuYenidenBaglanmaz: "Sunucu yedeği yeniden bağlanmaz: kasa kodu değiştiyse yeni kodu girin.",
  },

  /** Yetkilendirme penceresi (`yedek/oauth.ts`). */
  oauth: {
    pencereEngellendi: "Açılır pencere engellendi. Tarayıcının bu site için açılır pencereye izin vermesi gerekiyor.",
    iptal: "Bağlantı iptal edildi.",
    zamanAsimi: "Bağlantı zaman aşımına uğradı (5 dakika).",
    yetkiYok: (sebep: string) => `Sağlayıcı yetki vermedi: ${sebep}`,
    belirtecYok: (durum: number, sebep: string) => `Belirteç alınamadı (${durum}): ${sebep}`,
  },

  /** Cihazdaki yedek kaydı ve yedekleyici (`yedek/kasa.ts`, `yedek/yedekleyici.ts`, `lib/pfai.ts`). */
  kayit: {
    idbIstek: "IndexedDB isteği başarısız",
    idbYokKurulamaz: "Bu tarayıcıda IndexedDB yok — otomatik yedek kurulamaz.",
    idbIslem: "IndexedDB işlemi başarısız",
    idbIptal: "IndexedDB işlemi iptal edildi",
    idbYok: "Bu tarayıcıda IndexedDB yok.",
    idbAcilamadi: "IndexedDB açılamadı",
    idbDustu: "IndexedDB işlemi düştü",
    kasaBos: "Kasa boş — boş kasa buluta yazılmaz (buluttaki son yedeğin üzerine yazılmasın diye).",
    anahtarYok: "Yedek kaydında anahtar yok — kilitli kasa olmadan yazılamaz.",
    kuruluDegil: "Otomatik yedek kurulu değil.",
    modulUyumsuz:
      "Yedekleme modülü yüklendi ama beklenen işlevleri taşımıyor — web paketi ile kod sürümü ayrışmış olabilir.",
  },

  /** Yedek bağlamı (`yedek/YedekSaglayici.tsx`). */
  saglayici: {
    parolaGerekli: "Yedek parolası gerekli.",
    eskiYedekParolayla: "Eski yedek parolayla açılır.",
    degistirmeKilitli: "Kasa değiştirme yalnızca şifreli (kilitli) kasada yapılır.",
    sunucuDegil: "Kurulu hedef Parafon sunucusu değil.",
    anahtarYok: "Yedek anahtarı yok — önce otomatik yedeği yeniden kurun.",
  },

  qr: {
    sigmiyor: "İçerik QR'a sığmıyor; linki ya da dosyayı kullanın.",
    kameraYok: "Bu tarayıcı kameraya erişemiyor; kodu elle yazın.",
    kameraIzni: "Kamera izni verilmedi. Kodu elle yazın ya da tarayıcının site ayarlarından kameraya izin verin.",
    kameraBulunamadi: "Bu cihazda kullanılabilir bir kamera bulunamadı; kodu elle yazın.",
    kameraAcilamadi: "Kamera açılamadı; kodu elle yazın.",
    kodQr: "Kasa kodunun QR'ı",
    hazirlaniyor: "QR hazırlanıyor…",
    okut: "QR okut",
    kameraGoruntusu: "Kamera görüntüsü",
    cerceveyeTutun:
      "Öbür cihazdaki kasa kodu QR'ını çerçeveye tutun. Görüntü bu cihazda işlenir, hiçbir yere gönderilmez.",
    yabanci: "Okunan QR bir kasa kodu değil; aramaya devam ediliyor.",
    kameraKapat: "Kamerayı kapat",
  },

  bant: {
    cakisma: (n: number) =>
      `Eşitlemede ${n} kayıtta çakışma: iki cihaz da değiştirmişti, sonraki değişiklik tutuldu.`,
    bekliyorBuluta: "Bulut yedeği bekliyor: yazmak için buluta yeniden bağlanmak gerekiyor.",
    bekliyorHedef: (ad: string) => `Bulut yedeği bekliyor: yazmak için ${ad}'a yeniden bağlanmak gerekiyor.`,
    yazilamadi: (mesaj: string) => `Buluttaki kopya yazılamadı: ${mesaj} ·`,
    ayarlar: "Ayarlar",
    yalnizcaTarayicida: "Kasanız yalnızca bu tarayıcıda duruyor — bulut depolama seçilmedi.",
    ayarlarDepolama: "Ayarlar › Depolama",
    indirilmemis: "Kasada yedeği indirilmemiş değişiklik var.",
    ayarDegisti: "Ayarlarda değişiklik var, yedeği indirmek ister misiniz?",
    yedegiIndir: "Yedeği indir",
    indiMi: (dosya: string) => `Yedek dosyası (${dosya}) indi mi? İndirilenler klasörünüze bakın.`,
    indi: "İndi",
    inmedi: "İnmedi",
  },

  otoIndir: {
    baslik: "Değişiklikte otomatik indir",
    aciklama:
      "Bulut depolama bağlı değilken kasa değişince şifreli yedek dosyası (.pfai) bu cihaza iner. Dosya kasanın parolasıyla ya da 24 kelimelik kurtarma ifadesiyle açılır.",
    bulutBagli:
      "Bulut depolama bağlı: her değişiklik zaten buluta yazılıyor, otomatik indirme kapalı. Bulut kaldırılınca yeniden açılabilir.",
    bekleme: "Değişiklikten sonra bekleme",
    saniye: (n: number) => `${n} sn`,
    dakika: (n: number) => `${n} dk`,
    uyariBaslik: "İndirmeleri denetlemek sizin sorumluluğunuzda",
    uyari1:
      "Otomatik indirme tarayıcının indirme iznine bağlıdır. Tarayıcı bir indirmeyi engellerse, onay bekletirse ya da dosya kaydedilemezse Parafon bunu bilemez: indirme hataları size bildirilemeyebilir.",
    uyari2:
      "İndirilen dosyaların gerçekten cihazınıza indiğini düzenli olarak denetlemek ve onları cihaz dışında saklamak sizin sorumluluğunuzdadır. Bu cihaz kaybolur ya da tarayıcı verisi silinirse kasanız yalnızca bu dosyalardan geri gelir.",
    sonIndirme: (dosya: string, zaman: string) => `Son indirme: ${dosya} · ${zaman}`,
    sonIndirmeYok: "Henüz indirilmedi.",
    simdiIndir: "Şimdi indir",
    izinYok:
      "Bu tarayıcıda dosyanın inmediğini söylediniz: otomatik indirme bu cihazda duruyor, değişiklikte üstte uyarı çıkıyor.",
    yenidenDene: "Yeniden dene",
    geriYukleme:
      "Geri yüklemek için: yeni bir cihazda kurulum ekranındaki “Buluttan getir” › “bu cihazdaki bir yedek dosyasından”; bu kasada Ayarlar › Şifreli yedek › Yedekten geri yükle.",
  },

  soru: {
    baslik: "Kasanız nerede dursun?",
    sonradan: "Sonradan Ayarlar › Depolama’dan değiştirebilirsiniz.",
    uyariAdi: "Depolama seçilmedi",
    neYapmali: "Kasanın yalnızca bu cihazda mı, bulutta mı duracağını Ayarlar › Depolama’dan seçin.",
    serit: (ad: string) => `${ad}: kasanız nerede dursun?`,
  },

  /** Ayarlar › Depolama (`components/BulutYedegiKarti.tsx`). */
  depolama: {
    cakismaTuru: {
      account: "Hesap",
      transaction: "Hareket",
      manualValuation: "Elle değer",
      manualPrice: "Elle fiyat",
      setting: "Ayar",
    },
    bulutSatiri:
      "Kasa bu cihazda da durur; bulutta, sağlayıcının açamadığı şifreli bir kopyası olur ve her değişiklikte güncellenir.",
    baslik: "Depolama",
    okunuyor: "Depolama durumu okunuyor…",
    geriYuklemeTamam: "Buluttan geri yükleme tamamlandı",
    kilidiKullaniyor: "Bu cihaz artık o kasanın kilidini kullanıyor",
    anahtarBenimsendi:
      "Yedeğin alındığı kasanın PAROLASI ve 24 KELİMESİ bu cihazda da geçerli. Kurulumda bu cihaz için gösterilen kelimeler artık geçersiz.",
    koddaKasaYok: "Bu kodda henüz kasa yok. Yeni bir başlangıç için “Yeni kasa kodu oluştur”u seçin.",
    yedekParolasiGerekli: "Yedek parolası gerekli (yeni kopya bu parolayla şifrelenir).",
    kasaNeredeDursun: "Kasa nerede dursun",
    yalnizcaCihaz: "Yalnızca bu cihazda",
    yalnizcaCihazAciklama:
      "Tarayıcının site verisi silinirse ya da cihaz kaybolursa kasa gider. Aşağıdaki “Şifreli yedek (.pfai)” ile elle dosya alabilirsiniz.",
    bulutDepolama: "Bulut depolama",
    yalnizcaCihazKalsin: "Yalnızca bu cihazda kalsın",
    baskaCihazdaKullandiysaniz:
      "Başka bir cihazda Parafon kullandıysanız orada seçtiğiniz yeri seçin: kasanız buradan gelir.",
    yedekParolasi: "Yedek parolası",
    yedekParolasiIpucu:
      "Bir kez sorulur. Başka cihazda ya da site verisi silinince geri yüklemek için gerekir; kaybolursa yedek açılamaz.",
    parolaTekrar: "Parola (tekrar)",
    buluttaDosyaVar: (n: number) => `Bu bulutta ${n} yedek dosyası var`,
    kasaBos:
      "Bu cihazdaki kasa şu an boş. Başka bir cihazdaki kasanızı getirmek için dosyayı seçip kasanın parolasını girin; ardından bu cihaz aynı yere eşitlenir.",
    buCihazdakiyleBasla: "Bu cihazdakiyle başla",

    // Sağlayıcı seçici
    baglan: "Bağlan",
    bulutSaglayicisi: "Bulut sağlayıcısı",
    saglayiciSecin: "Bir sağlayıcı seçin.",
    ikiParolaAyniDegil: "İki parola aynı değil.",
    saglayiciYok: "Bu tarayıcıda şu an kullanılabilir bir bulut sağlayıcısı yok",
    saglayiciYokMetin:
      "Her seçeneğin altında neden kapalı olduğu yazıyor. O zamana kadar “Şifreli yedek (.pfai)” ile elle yedek alın.",
    baglaniyor: "Bağlanıyor…",

    // Kurulu durum
    sunucuKopyasiSilinsin: "Parafon sunucusundaki şifreli kopya silinsin",
    nerede: "Nerede",
    sonYedek: "Son yedek",
    henuzYok: "henüz yok",
    oburCihazlardan: "Öbür cihazlardan",
    henuzBakilmadi: "henüz bakılmadı",
    baskaCihazYok: (zaman: string) => `bu kasayı kullanan başka cihaz yok · ${zaman}`,
    degisiklikAlindi: (n: number, zaman: string) => `${n} değişiklik alındı · ${zaman}`,
    cakismaBaslik: (n: number) => `Son eşitlemede ${n} kayıtta çakışma`,
    cakismaAciklama:
      "Bu kayıtları son eşitlemeden sonra iki cihaz da değiştirmişti. Her birinde sonraki değişiklik tutuldu:",
    buCihazdaki: "bu cihazdaki",
    oburCihazdaki: "öbür cihazdaki",
    cakismaSatiri: (tur: string, etiket: string, kazanan: string) => `${tur} “${etiket}” — ${kazanan} sürüm tutuldu`,
    elleDuzeltin: "Kaybolan değişiklik gerekiyorsa o kaydı elle düzeltin.",
    baglantiYenilenmeli: "Yedek bekliyor — bağlantı yenilenmeli",
    baglantiYenilenmeliMetin:
      "Buluta yazmak için tarayıcı bir tıklama istiyor (izin ya da erişim süresi doldu). Yazılmamış değişiklikler bu tarayıcıda duruyor.",
    sonYedekYazilamadi: "Son yedek yazılamadı",
    yenidenDenenir: "Bir sonraki değişiklikte ya da “Şimdi yedekle” ile yeniden denenir.",
    yedekleniyor: "Yedekleniyor…",
    degisiklikVar: "Değişiklik var; birkaç saniye içinde yedeklenecek.",
    yenidenBaglan: "Yeniden bağlan",
    hedefeYenidenBaglan: (ad: string) => `${ad}'a yeniden bağlan`,
    simdiYedekle: "Şimdi yedekle",
    depolamayiDegistir: "Depolamayı değiştir…",
    yalnizcaCihazaDon: "Yalnızca bu cihaza dön…",
    yeniYerAciklama:
      "Yeni yere bağlanınca kasanın şifreli kopyası hemen oraya yazılır. Kendi bulut hesabınızdaki eski dosyalara Parafon dokunmaz.",
    baglanVeTasi: "Bağlan ve buraya taşı",
    yeniBulutSaglayicisi: "Yeni bulut sağlayıcısı",
    yalnizcaCihazKalsinMi: "Yalnızca bu cihazda kalsın mı?",
    yalnizcaCihazKalsinMiMetin:
      "Buluta kopya yazılması durur. Site verisi silinirse ya da cihaz kaybolursa kasa gider.",

    // Buluttaki dosyalar
    kuruluBulutYok: "Kurulu bir bulut yok.",
    buluttakiDosyalar: "Buluttaki dosyalar",
    dosyalariListele: "Yedek dosyalarını listele",

    // Parafon sunucusu
    kasaKodunuGirin: "Kasa kodunu girin.",
    kisaParola: (n: number) =>
      `Parafon sunucusu için kasa parolası en az ${n} karakter olmalı. Önce Ayarlar › Kasa kilidi › “Parolayı değiştir” ile parolanızı uzatın, sonra buraya dönün.`,
    kasaParolanizGirin: "Kasa parolanızı girin.",
    dogrulanamiyor: "Parola bu derlemede doğrulanamıyor; sayfayı yenileyin.",
    parolaYanlis: "Parola yanlış: bu kasanın parolasını girin.",
    kasaKodu: "Kasa kodu",
    yeniKodOlustur: "Yeni kasa kodu oluştur",
    baskaCihazinKodu: "Bu kasayı kullanan başka bir cihazın kodunu gir",
    kasaKoduIpucu: "Öbür cihazda Ayarlar › Otomatik bulut yedeği altında görünür. Tireleri yazmasanız da olur.",
    kasaParolaniz: "Kasa parolanız",
    kasaParolanizIpucu: (n: number) =>
      `En az ${n} karakter olmalı. Kasa kodunu ele geçiren biri şifreli dosyayı indirip parolayı kendi bilgisayarında deneyebilir; uzun bir parola bunu pratikte imkânsız kılar.`,
    kodAdres: (ay: number) =>
      `Kod yalnızca bir adres: dosyalar parolanız ya da 24 kelimenizle açılır, Parafon sunucusu açamaz. Sunucu kodu ve sizi bilmez. Hiçbir cihazdan ${ay} ay açılmayan kasa klasörü sunucudan kesin olarak silinir — size haber verilemez, çünkü sunucu kim olduğunuzu bilmez.`,
    gizle: "Gizle",
    goster: "Göster",
    qrGizle: "QR'ı gizle",
    qrGoster: "QR göster",
    kopyalandi: "Kopyalandı",
    kopyala: "Kopyala",
    baskaCihazdaAc: (ay: number) =>
      `Bu kasayı başka bir cihazda açmak için o cihazda Ayarlar › Otomatik bulut yedeği › Parafon sunucusu’nu seçip bu kodu girin. Kodu yalnızca kendi cihazlarınıza yazın. Hiçbir cihazdan ${ay} ay açılmayan klasör silinir.`,
    qrOkutun: "Öbür cihazda “QR okut” ile okutun. QR'da yalnızca kod var; tek başına dosyaları açmaz.",
    kodBulunamadi: "Yedek bekliyor — kasa kodu sunucuda bulunamadı",
    kodBulunamadiMetin: (ay: number) =>
      `Kod başka bir cihazda yenilenmiş ya da klasör ${ay} ay hiçbir cihazdan açılmadığı için silinmiş olabilir. Yeni kodu öbür cihazdan alıp girin; yazılmamış değişiklikler bu tarayıcıda duruyor.`,
    yeniKasaKodu: "Yeni kasa kodu",
    kodHatali: "Kasa kodu eksik ya da hatalı.",
    koduKaydet: "Kodu kaydet",
    koduYenile: "Kodu yenile…",
    yenilensinMi: "Kasa kodu yenilensin mi?",
    yenilensinMiMetin:
      "Kod başkasının eline geçtiyse yenileyin. Yeni bir klasör açılır, bütün yedek dosyaları oraya taşınır ve eski klasör sunucudan silinir. Bu kasayı kullanan öbür cihazlara yeni kodu elle girmeniz gerekir; o zamana kadar onların yedeği bekler.",
    yenileniyor: "Yenileniyor…",
    yenile: "Yenile",

    // Dosya seç ve yükle
    pfaiYok: "Bu hedefte .pfai dosyası yok.",
    yedekDosyasi: "Yedek dosyası",
    yedegiNeyleAcacaksiniz: "Yedeği neyle açacaksınız",
    kasaninParolasi: "Yedeğin alındığı kasanın parolası",
    yedeginParolasi: "Yedeğin parolası",
    eskiBicimIpucu: "Eski biçimli (ayrı yedek parolalı) dosyalarda o zamanki yedek parolası.",
    cozuluyor: "Çözülüyor…",
    bununlaDegistir: "Bu cihazdaki kasayı bununla değiştir",
    geriYukle: "Geri yükle",
    baskaKasaya: "Bu yedek başka bir kasaya ait",
    baskaKasayaMetin:
      "Seçtiğiniz dosya bu cihazdaki kasanın değil, başka bir kasanın yedeği. İki ayrı kasa birleştirilmez; hiçbir şey değişmedi.",
    yerineKoyabilirsiniz: "O kasayı bu cihazda kullanmak istiyorsanız bu cihazdaki kasanın yerine koyabilirsiniz.",
    yerineKoy: "Bu cihazdaki kasanın yerine koy…",

    // Başka kasa aç
    kasaDegisti: "Kasa değişti",
    degistiKilit:
      "Bundan sonra bu cihazda o kasanın PAROLASI ve 24 KELİMESİ geçerli. Bu cihazın eski parolası ve kelimeleri artık hiçbir şeyi açmaz.",
    degistiYedek:
      "Otomatik bulut yedeği açıksa açık kalır; yeni kasa kendi adlı dosyalara yazılır, eski kasanın buluttaki yedeği olduğu gibi durur.",
    yeniKasayiAc: "Yeni kasayı aç",
    silinecek: "Bu cihazdaki kasa silinecek",
    silinecekOn: "Bu cihazdaki kasa",
    silinecekSayi: (hesap: number, hareket: number) => `${hesap} hesap, ${hareket} hareket`,
    silinecekSon: "bu cihazdan kalkacak; seçeceğiniz buluttaki kasa onun yerine gelecek. İki kasa birleştirilmez.",
    kilitDegisir: "Bu cihazın parolası ve 24 kelimesi geçersiz olur; gelen kasanın parolası ve 24 kelimesi geçerli olur.",
    onceSaklayin:
      "Önce eski kasayı saklayın (önerilir). İndirilen dosya bu cihazın şu anki parolası ya da 24 kelimesiyle açılır; sonradan aynı yoldan geri getirilebilir.",
    eskiIndirildi: "Eski kasa indirildi ✓",
    eskiIndir: "Eski kasayı dosyaya indir",
    kaydetmedenDevam: "Eski kasayı kaydetmeden devam ediyorum",
    getirilecekNerede: "Getirilecek kasanın yedeği nerede",
  },
};
